/**
 * @generated SignedSource<<1c1949292bb086f9ab42d5ae33ff66c8>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface CommentBody {
  representationFormat: ContentRepresentation;
  value: Scalars["String"]["input"];
}
export enum ContentRepresentation {
  ATLAS_DOC_FORMAT = "ATLAS_DOC_FORMAT",
  EDITOR = "EDITOR",
  EDITOR2 = "EDITOR2",
  EXPORT_VIEW = "EXPORT_VIEW",
  PLAIN = "PLAIN",
  RAW = "RAW",
  STORAGE = "STORAGE",
  STYLED_VIEW = "STYLED_VIEW",
  VIEW = "VIEW",
  WIKI = "WIKI",
}
export interface UpdateCommentInput {
  commentBody: CommentBody;
  commentId: Scalars["ID"]["input"];
  /** This field is being deprecated, you do not need to provide this value if the update.comment.mutations.optional.version FF is on */
  version?: InputMaybe<Scalars["Int"]["input"]>;
}
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by =

    | EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_Anonymous
    | EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_KnownUser
    | EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_UnknownUser
    | EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by_User;
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version =
  {
    __typename?: "Version";
    number: number | null;
    when: string | null;
    by: EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version_by | null;
  };
export type EditCommentUpdateInlineCommentMutation_updateComment_Comment = {
  __typename?: "Comment";
  id: string;
  body?: EditCommentUpdateInlineCommentMutation_updateComment_Comment_body_DocumentBody;
  version?: EditCommentUpdateInlineCommentMutation_updateComment_Comment_version_Version;
};
export type EditCommentUpdateInlineCommentMutation_Mutation = {
  __typename?: "Mutation";
  updateComment: EditCommentUpdateInlineCommentMutation_updateComment_Comment;
};
export type EditCommentUpdateInlineCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
  includeVersionFields?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;
export type EditCommentUpdateInlineCommentMutation =
  EditCommentUpdateInlineCommentMutation_Mutation;
